module.exports = __webpack_public_path__ + "static/media/5Anniversary.c4d2872c.png";